// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    userId: z.string().min(1).max(12),
    country: z.string().min(1).max(16),
    lastSignInAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    userId: z.string().min(1).max(12),
    country: z.string().min(1).max(16),
    lastSignInAt: z.number(),
});
export const UserSignInCountries = Object.freeze({
    table: 'user_sign_in_countries',
    tableSingular: 'user_sign_in_country',
    fields: {
        tenantId: 'tenant_id',
        userId: 'user_id',
        country: 'country',
        lastSignInAt: 'last_sign_in_at',
    },
    fieldKeys: [
        'tenantId',
        'userId',
        'country',
        'lastSignInAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
